module.exports = __webpack_public_path__ + "static/6-57f0f6f13d0a964dae5d77b01480ea73.jpg";